export function getDustReduced (idleStopTime, fuelType = 0) {
  const constants = {
    '미지정': 0,
    '경유': 0.00332,
    'CNG': 0.00117
  }

  let constant = 0
  if (typeof fuelType === 'string') {
    constant = constants[fuelType] || 0
  } else if (typeof fuelType === 'number') {
    const symbol = {
      0: '미지정',
      1: '경유',
      2: 'CNG'
    }

    const key = symbol[fuelType] || '미지정'

    constant = constants[key] || 0
  }

  return idleStopTime * constant
}

export function id2date (_id) {
  if (!_id) return null
  _id += ''
  if (_id.length !== 24) return _id
  return new Date(parseInt(_id.substring(0, 8), 16) * 1000)
}
